import React from "react";
import AppBar from "./components/AppBar";
import Footer from "./components/Footer";
import MetaTags from "./components/MetaTags";
import { Container, Row, Col } from "react-bootstrap";
import { FaRegFaceSmile } from "react-icons/fa6";
import { PiSmileySadBold } from "react-icons/pi";
const SafetyTips = () => {
  return (
    <div>
      <MetaTags
        title="Safety Tips - GMR Crackers - Wholesale Crackers Sivakasi"
        type="website"
        siteName="gmrcrackers.com"
        url="https://gmrcrackers.com/safetytips"
        keywords="Safety Tips | GMR Crackers | Fireworks Safety | Sivakasi Crackers"
        description="Learn essential safety tips for handling fireworks safely from GMR Crackers."
        revisitAfter="10 Days"
      />
      <AppBar />
      <img
        src={require("../assets/images/banner/banner05.jpg")}
        className="img-fluid w-100"
        alt="GMR Crackers Safety Tips Banner"
      />
      
      <div className="padding bg-white">
        <Container>
          <Row>
            <Col lg="12" className="text-center pb-4">
              <span className="badge bg-success-subtle text-success border border-success-subtle px-3 py-1 rounded-pill bold text-uppercase mb-2">
                Celebration with Safety
              </span>
              <h1 className="bold text-center lg-font text-dark mt-2 mb-2">
                Fireworks Safety Tips
              </h1>
              <p className="text-muted bold fs-5 mx-auto" style={{ maxWidth: "650px" }}>
                GMR Crackers wishes everyone a joyful, bright, and accident-free celebration. Please adhere to these essential guidelines:
              </p>
            </Col>

            {/* Do's Section */}
            <Col lg="12" className="py-2">
              <div className="text-center mb-4">
                <span className="title shadow-sm bg-green px-4 py-2 rounded-pill bold text-uppercase">
                  ✓ DO's — Always Follow
                </span>
              </div>
            </Col>

            <Col lg="4" md="6" className="py-2">
              <div className="safe-list box-green p-3 h-100 rounded-3 shadow-sm border">
                <div className="safe-icon fs-2 me-3">
                  <FaRegFaceSmile />
                </div>
                <div className="safe-desc">
                  <div><strong className="text-warning">Read Instructions:</strong> Always check safety instructions and warning labels printed on each cracker pack.</div>
                </div>
              </div>
            </Col>

            <Col lg="4" md="6" className="py-2">
              <div className="safe-list box-green p-3 h-100 rounded-3 shadow-sm border">
                <div className="safe-icon fs-2 me-3">
                  <FaRegFaceSmile />
                </div>
                <div className="safe-desc">
                  <div><strong className="text-warning">Authorized Dealers:</strong> Buy fireworks directly from licensed manufacturers like GMR Crackers.</div>
                </div>
              </div>
            </Col>

            <Col lg="4" md="6" className="py-2">
              <div className="safe-list box-green p-3 h-100 rounded-3 shadow-sm border">
                <div className="safe-icon fs-2 me-3">
                  <FaRegFaceSmile />
                </div>
                <div className="safe-desc">
                  <div><strong className="text-warning">Eye Protection:</strong> Wear protective eyewear and cotton clothes while lighting fireworks.</div>
                </div>
              </div>
            </Col>

            <Col lg="4" md="6" className="py-2">
              <div className="safe-list box-green p-3 h-100 rounded-3 shadow-sm border">
                <div className="safe-icon fs-2 me-3">
                  <FaRegFaceSmile />
                </div>
                <div className="safe-desc">
                  <div><strong className="text-warning">Use Agarbatti:</strong> Always use a long incense stick (agarbatti) or sparkler to ignite fuses at arm's length.</div>
                </div>
              </div>
            </Col>

            <Col lg="4" md="6" className="py-2">
              <div className="safe-list box-green p-3 h-100 rounded-3 shadow-sm border">
                <div className="safe-icon fs-2 me-3">
                  <FaRegFaceSmile />
                </div>
                <div className="safe-desc">
                  <div><strong className="text-warning">Dry Storage:</strong> Store all crackers in a cool, moisture-free place away from heat sources.</div>
                </div>
              </div>
            </Col>

            <Col lg="4" md="6" className="py-2">
              <div className="safe-list box-green p-3 h-100 rounded-3 shadow-sm border">
                <div className="safe-icon fs-2 me-3">
                  <FaRegFaceSmile />
                </div>
                <div className="safe-desc">
                  <div><strong className="text-warning">Adult Supervision:</strong> Children must always ignite crackers under strict adult presence.</div>
                </div>
              </div>
            </Col>

            {/* Don'ts Section */}
            <Col lg="12" className="pt-5 pb-2">
              <div className="text-center mb-4">
                <span className="title shadow-sm bg-red px-4 py-2 rounded-pill bold text-uppercase">
                  ✗ DON'Ts — Strictly Avoid
                </span>
              </div>
            </Col>

            <Col lg="4" md="6" className="py-2">
              <div className="safe-list box-red p-3 h-100 rounded-3 shadow-sm border">
                <div className="safe-icon fs-2 me-3">
                  <PiSmileySadBold />
                </div>
                <div className="safe-desc">
                  <div><strong className="text-warning">No Indoor Use:</strong> Never ignite fireworks indoors, on balconies, or near dry vegetation.</div>
                </div>
              </div>
            </Col>

            <Col lg="4" md="6" className="py-2">
              <div className="safe-list box-red p-3 h-100 rounded-3 shadow-sm border">
                <div className="safe-icon fs-2 me-3">
                  <PiSmileySadBold />
                </div>
                <div className="safe-desc">
                  <div><strong className="text-warning">No Open Flames:</strong> Don’t store firecrackers near lit candles, oil lamps, or electric heaters.</div>
                </div>
              </div>
            </Col>

            <Col lg="4" md="6" className="py-2">
              <div className="safe-list box-red p-3 h-100 rounded-3 shadow-sm border">
                <div className="safe-icon fs-2 me-3">
                  <PiSmileySadBold />
                </div>
                <div className="safe-desc">
                  <div><strong className="text-warning">No Loose Clothing:</strong> Avoid wearing synthetic, nylon, or loose flowing attire when near fireworks.</div>
                </div>
              </div>
            </Col>

            <Col lg="4" md="6" className="py-2">
              <div className="safe-list box-red p-3 h-100 rounded-3 shadow-sm border">
                <div className="safe-icon fs-2 me-3">
                  <PiSmileySadBold />
                </div>
                <div className="safe-desc">
                  <div><strong className="text-warning">Never Aim at People:</strong> Never point, aim, or throw fireworks at anyone, including animals.</div>
                </div>
              </div>
            </Col>

            <Col lg="4" md="6" className="py-2">
              <div className="safe-list box-red p-3 h-100 rounded-3 shadow-sm border">
                <div className="safe-icon fs-2 me-3">
                  <PiSmileySadBold />
                </div>
                <div className="safe-desc">
                  <div><strong className="text-warning">Stay Alert:</strong> Never consume alcohol before or while lighting crackers; alertness saves lives.</div>
                </div>
              </div>
            </Col>

            <Col lg="4" md="6" className="py-2">
              <div className="safe-list box-red p-3 h-100 rounded-3 shadow-sm border">
                <div className="safe-icon fs-2 me-3">
                  <PiSmileySadBold />
                </div>
                <div className="safe-desc">
                  <div><strong className="text-warning">Never Relight Duds:</strong> If a cracker fails to ignite, do not inspect it closely; douse it with water.</div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <Footer />
    </div>
  );
};

export default SafetyTips;
